export function deepCopyObject(object: any): any {
  return JSON.parse(JSON.stringify(object));
}
